<template>
  <div class="header">
    <div class="col-10 header-title">Espace candidat</div>
    <router-link :to="{ name: 'public-homepage'}" class="col-2 header-logo"><img src="@/assets/img/logo.png"></router-link>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {}
};
</script>
